import { FormControlLabel, Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import WhiteBackgroundCheckbox from "./WhiteBackgroundCheckbox";
import { palette } from "../theme/palette";

const useStyles = makeStyles({
  container: {
    marginLeft: 0,
  },
  label: {
    color: (props) =>
      props.disabled
        ? palette.typography.white.disabled
        : palette.typography.white.solid,
    cursor: "default",
    fontSize: "0.75rem",
    lineHeight: "1rem",
    marginRight: "0.25rem",
  },
});

export const CheckboxWithLabel = ({
  label,
  checked = false,
  onChange,
  disabled,
  sentryId,
}) => {
  const styles = useStyles({ disabled });

  return (
    <FormControlLabel
      label={<Typography className={styles.label}>{label}</Typography>}
      className={styles.container}
      control={
        <WhiteBackgroundCheckbox
          disabled={disabled}
          style={{ color: palette.typography.white.solid }}
          checked={checked}
          onChange={() => onChange && onChange(!checked)}
        />
      }
      sentryId={sentryId}
    />
  );
};
